import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const StyleTextField = withStyles((theme) => ({
    root: {
      backgroundColor: 'white',
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: 'black',
          borderWidth: '2px',
        }
      },
      '& .MuiTypography-root':{
        fontFamily: 'Kanit'
      }
    },
}))((props) => <TextField color="default" {...props} />);

function CustomTextField({...props}) {
  return (
    <StyleTextField 
    {...props}
    />
  );
}

export default CustomTextField;
